export class Personnel {
  constructor(public readonly name: string) {}
}
